//
//
//
//
//
//
//
//
//
//

import CollaboratorIcon from './CollaboratorIcon.vue'
export default {
  components: {
    CollaboratorIcon,
  },
  props: {
    names: {
      type: String,
      required: true,
    },
    status: {
      type: String,
      default: 'pending',
    },
  },
}
